module.exports = __webpack_public_path__ + "static/media/fail-payment.2119ee94.svg";